import { Inject, Injectable } from '@angular/core';

import { Environment, DivisioniAd, ModelStrStr } from '../../models/-index';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class DivisioniAdService extends CrudGenericsService<DivisioniAd, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/DivisioniAd`);
    this.base = `${env.apiUrl}/api/DivisioniAd/`;
  }
  SuggestWrite(): Observable<ModelStrStr[]> {
    const url = this.base + 'SuggestWrite';
    return this.http.get<ModelStrStr[]>(`${url}`);
  }
  Diagnostic_GetAdAllGroups(domain: string, user: string | null = null): Observable<ModelStrStr[]> {
    const url = this.base + 'Diagnostic_GetAdAllGroups?domain=' + domain + '&user=' + user;
    return this.http.get<ModelStrStr[]>(`${url}`);
  }
}
